// NPM
import React from "react"

// Components
import FooterBottomLinks from "./FooterBottomLinks"
import FooterBottomSocial from "./FooterBottomSocial"

const FooterBottom = ({ sections, socialMedia }) => {
  const descriptionSection = sections.find(
    s => s.uuid === "bottomNav_footerDisclaimer",
  )

  return (
    <div className="FooterBottom">
      <div className="FooterBottom__left">
        <FooterBottomLinks sections={sections} />
        {descriptionSection && (
          <p className="FooterBottom__left-description">
            {descriptionSection.title.replace(
              "$YEAR",
              new Date().getFullYear(),
            )}
          </p>
        )}
      </div>

      <div className="FooterBottom__right">
        <FooterBottomSocial socialMedia={socialMedia} />
      </div>
    </div>
  )
}

export default FooterBottom
